module.exports = __webpack_public_path__ + "static/media/details__court.5996ddab.svg";